import { render } from "./ShopDisplayFixed.vue?vue&type=template&id=694f3aac&scoped=true"
import script from "./ShopDisplayFixed.vue?vue&type=script&lang=js"
export * from "./ShopDisplayFixed.vue?vue&type=script&lang=js"

import "./ShopDisplayFixed.vue?vue&type=style&index=0&id=694f3aac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694f3aac"]])

export default __exports__